export enum RewardsOperationsEnum {
    'For Every' = 1,
    'Greather Than' = 2,
    'Lower Than' = 3,
}

